import {Nested} from "react-form";
import {Api} from "common/Api";

const request_path = "/?rest_route=/affinipay/v1/save";

export default class SettingsApi extends Api {
    public save = (content: Nested<any>) => this.post(request_path, content)
}


// WEBPACK FOOTER //
// ./src/settings/SettingsApi.tsx